(() => {
  // Native details keeps mobile navigation usable even without JavaScript.
  document.addEventListener('click', e => {
    document.querySelectorAll('.tr-mobile-menu[open]').forEach(menu => {
      if (!menu.contains(e.target) || e.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.tr-mobile-menu[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  window.matchMedia('(max-width: 720px)').addEventListener('change', e => {
    if (!e.matches) document.querySelectorAll('.tr-mobile-menu[open]').forEach(menu => { menu.open = false; });
  });
  function cookieFooterReady() {
    const ready = !!document.querySelector('[data-tr-cookie-settings]') &&
      typeof window.CCM?.openControlPanel === 'function';
    document.documentElement.classList.toggle('tr-cookie-footer-ready', ready);
    return ready;
  }
  document.addEventListener('click', e => {
    const link = e.target.closest('[data-tr-cookie-settings]');
    if (!link || typeof window.CCM?.openControlPanel !== 'function') return;
    e.preventDefault();
    window.CCM.openControlPanel();
  });
  let cookieChecks = 0;
  const cookieTimer = setInterval(() => {
    if (cookieFooterReady() || ++cookieChecks >= 240) clearInterval(cookieTimer);
  }, 250);
  window.addEventListener('load', cookieFooterReady);
  function init(root = document) {
    cookieFooterReady();
    root.querySelectorAll('[data-tr-product]').forEach(el => {
      if (el.dataset.ready || !el.querySelector('[data-tr-labels]') || !el.querySelector('[data-tr-variants]')) return; el.dataset.ready = '1';
      const variants = JSON.parse(el.querySelector('[data-tr-variants]').textContent);
      const labels = JSON.parse(el.querySelector('[data-tr-labels]').textContent);
      const img = el.querySelector('.tr-main-image');
      function image(url, alt) { if (img && url) { img.src = url; img.removeAttribute('srcset'); if (alt) img.alt = alt; } }
      el.querySelectorAll('[data-tr-image]').forEach(b => b.addEventListener('click', () => image(b.dataset.trImage, b.dataset.trAlt)));
      el.querySelector('[data-tr-variant]').addEventListener('change', e => {
        const v = variants.find(v => String(v.id) === e.target.value);
        if (!v) return;
        const p = el.querySelector('[data-tr-price]'); p.textContent = v.price;
        if (v.compare) { const s = document.createElement('s'); s.textContent = v.compare; p.append(' ', s); }
        el.querySelector('[data-tr-unit]').textContent = v.unit;
        el.querySelector('[data-tr-sku]').textContent = v.sku || '';
        const b = el.querySelector('[data-tr-add]'); b.disabled = !v.available; b.textContent = v.available ? labels.add : labels.sold;
        const q = el.querySelector('[data-tr-quantity]'); q.min = v.min; q.step = v.step; q.value = v.min;
        if (v.max) q.max = v.max; else q.removeAttribute('max');
        image(v.image);
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      });
    });
    root.querySelectorAll('[data-tr-tab]').forEach(btn => {
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      btn.addEventListener('click', () => {
        const section = btn.closest('.shopify-section');
        section.querySelectorAll('[data-tr-tab]').forEach(b => { b.classList.toggle('active', b === btn); b.setAttribute('aria-pressed', String(b === btn)); });
        section.querySelectorAll('[data-tr-tone]').forEach(p => p.hidden = btn.dataset.trTab === 'all' ? p.hasAttribute('data-tr-tone-only') : p.dataset.trTone !== btn.dataset.trTab);
      });
    });
  }
  // Critical commerce controls must not wait for unrelated app/deferred scripts.
  var scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return; scheduled = true;
    requestAnimationFrame(() => { scheduled = false; init(); });
  });
  observer.observe(document.documentElement, {childList:true,subtree:true});
  init();
  document.addEventListener('DOMContentLoaded', () => { init(); observer.disconnect(); });
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
